module["exports"] = [
  "#{common_cell_prefix}-###-####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/cell_phone/formats.js
 ** module id = 1006
 ** module chunks = 0
 **/